module.exports = "/static-assets/_next/static/images/img-6946c1a038-fb89276be7a8006bedc6cfcaac3bc794.webp";